import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import { syncAndNavigate } from '@/utils/sync'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'ccp',
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    chain: 'btc',
    network: 'bitcoin',
    wallet: 'ledger',
    transport: 'usb',
    addressType: 'bech32',
    erc20: false,
    atomicSwap: false,
    orders: []
  },
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
    NEW_ORDER (state, order) {
      state.orders.push(order)
    },
    UPDATE_ORDER (state, order) {
      const item = state.orders.find(i => i.id === order.id)
      Object.assign(item, order)
    },
    NAVIGATE (state, { key, value }) {
      let init = false

      if (key === 'init') {
        key = undefined
        init = true
      }

      syncAndNavigate(key, value, init, query => {
        Object.entries(query).map(([ k, v ]) => {
          if (k && v === '') {
            delete query[k]
          }

          if (state[k] !== v) {
            state[k] = v
          }
        })
      })
    }
  },
  actions: {
    init ({ commit, state }) {
      commit('NAVIGATE', {
        key: 'init'
      })
    }
  },
  plugins: [vuexPersist.plugin]
})
